






import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { inquiryService } from '@/services/InquiryService';

@Component({})
export default class Priority extends Vue {
  @Prop() public priority!: number;
  @Prop() public inquiryId!: string;
  private currentPriority: number = this.priority || 1;
  private priorityLetter = 'A';
  private priorityClass = '';

  private changePriority() {
    if (this.currentPriority < 3) {
      this.currentPriority += 1;
    } else {
      this.currentPriority = 1;
    }
    const args = {
      priority: this.currentPriority,
      id: this.inquiryId
    };
    inquiryService.updateInquiry(args)
      .then(() => {
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 3000
        });
      }).catch((error) => {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: error.message,
          time: 3000
        });
      });
  }

  @Watch('currentPriority', { immediate: true })
  setPriority() {
    switch (this.currentPriority) {
      case 1:
        this.priorityLetter = 'A';
        this.priorityClass = 'priority--red';
        return;
      case 2:
        this.priorityLetter = 'B';
        this.priorityClass = 'priority--yellow';
        return;
      case 3:
        this.priorityLetter = 'C';
        this.priorityClass = 'priority--grey';
        return;
      default:
        this.priorityLetter = 'A';
        this.priorityClass = 'priority--red';
    }
  }
}
